module.exports = __webpack_public_path__ + "static/media/22.05d2dfc4.jpg";